import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const ProgressContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  padding: 0 32px;

  ${Media.Phone`
    padding: 0 24px;
    min-height: 234px;
    max-height: 234px;
  `}
`

export const Progress = styled.div`
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: ${Colors.Neutral10};
`

export const ProgressBar = styled.div<{ progress: number }>`
  width: ${props => `${props.progress}%`};
  height: inherit;
  border-radius: inherit;
  background-color: ${Colors.Blue50};
  transition: width 0.15s ease-out;
`

export const ProgressLabel = styled.span`
  ${Typography.S};
  ${FontWeights.Medium};

  color: ${Colors.Neutral90};
`
